<template>
	<b-modal
		id="loginModal"
		centered
		hide-header
		hide-footer
		body-class="p-0 login-modal-body"
		content-class="border-0 rounded-20 shadow-lg modal-bg-transparent"
		dialog-class="login-modal-dialog"
		footer-class="border-0"
		backdrop-class="onboarding-modal-backdrop"
		no-close-on-backdrop
		no-close-on-esc
		no-enforce-focus
		v-model="isOpen"
		@show="handleShow"
		@hide="handleHide"
	>
		<LoginContent :visible="isOpen" @close="isOpen = false" />
	</b-modal>
</template>

<script>
import loginMixin from "@/utils/mixins/loginMixin";
import LoginContent from "./LoginContent.vue";
import EventBus from "@/utils/EventBus";

export default {
	name: "LoginModal",
	mixins: [loginMixin],
	components: {
		LoginContent,
	},
	methods: {
		handleShow() {
			this.clearAndReset(false);
			EventBus.$emit("open-login-modal");
		},
		handleHide() {
			this.clearAndReset(true);
			EventBus.$emit("close-login-modal");
		},
	},
};
</script>
<style>
@media (max-width: 1028px) {
  body.login-modal-open .new-header,
  body.login-modal-open .mobile-header,
  body.login-modal-open .mob-bottom-nav {
    display: none !important;
  }
}
</style>
